// Lit la configuration unique définie dans public/version-config.js
// (chargée via <script> dans index.html -> window.__APP_CONFIG__).
const cfg = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export const APP_VERSION = cfg.version || 'v0';
export const BUILD_DATE = cfg.buildDate || '';
export const CACHE_NAME = cfg.cacheName || '';

// Onglets marqués « Nouveau » par version : à chaque mise à jour, déclarez ici
// les onglets modifiés pour la NOUVELLE version. Le badge apparaît automatiquement
// sur ces onglets, disparaît au 1er clic (mémorisé par version) et réapparaît à la MAJ suivante.
export const NEW_TABS_BY_VERSION = {
  'v0.1.0': ['about'],
  'v0.2.0': ['history'],
  'v0.3.0': ['expenses'],
  'v0.3.1': ['expenses'],
  'v0.5.3': ['members', 'expenses'],
  'v0.5.4': ['members', 'expenses'],
  'v0.5.5': ['members'],
  'v0.5.6': ['members', 'users'],
  'v0.5.7': [],
  'v0.5.8': [],
  'v0.5.9': ['history', 'subscriptions'],
  'v0.6.0': [],
  'v0.6.1': [],
  'v0.6.2': [],
  'v0.10.0': ['health'],
};

export const NEW_TABS = NEW_TABS_BY_VERSION[APP_VERSION] || [];
